<div class="p-6">
    <h3 class="titre3">{{ 'LEARNING_PATH_MANAGEMENT.DELETE_LEARNING_PATH_CONFIRM_TITLE' | translate }}</h3>
    <p class="mb-6">{{ 'LEARNING_PATH_MANAGEMENT.DELETE_LEARNING_PATH_CONFIRM_TEXT' | translate }}</p>
    <div class="flex justify-end space-x-4">
        <button (click)="annuler()" class="px-4 py-2 btn-secondary-novo">
            {{ 'LEARNING_PATH_MANAGEMENT.BUTTON_CANCEL' | translate }}
        </button>
        <button (click)="confirmerSuppression()" class="px-4 py-2 btn-primary-novo">
            {{ 'LEARNING_PATH_MANAGEMENT.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>
